import React, { useState } from 'react';
import { useStyles } from './_utility';
import { useStore } from '../../zustand';
import tipsIcon from '../../assets/icons/tipsIcon.png';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
const BUCKET_URL_INDEX = process.env.REACT_APP_BUCKET_URL_INDEX;

const RedirectPrompt = () => {
    // const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const classes = useStyles(dynamic_text_settings);
    const [open, setOpen] = React.useState(true);
    const [clicked, setClicked] = useState(false)
    const actions = useStore(state => state.actions);
    const { product_session_id, variant_session_id, variant_type } = useStore.getState().settings;
    const variant_id = useStore.getState().variant_id;

    // TODO: Test Redirect is working for in app browsers to get users out

    const handleClose = e => {
        setOpen(false)
        setTimeout(() => {
        actions.handleModalDisplay({ display: '', status: false })
        }, 750)
    };

    const generateLink = () => {
        let redirectURL;
        if(variant_type === 'bco') {
            redirectURL = `${BUCKET_URL_INDEX}?variant=${variant_type}_${variant_id}&variant_session_id=${variant_session_id}&product_session_id=${product_session_id}&origin=external`;
        } else {
            redirectURL = `${BUCKET_URL_INDEX}?variant=${variant_id}&variant_session_id=${variant_session_id}&product_session_id=${product_session_id}&origin=external`;
        }
        return redirectURL
    }

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="web-view-code"
            aria-describedby="web-view-modal"
            className={classes.root}
            open={open}
        >
            <section className={classes.modalClose}>
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                <CloseIcon />
                </IconButton>
            </section>
            <section className={classes.modalTitle}>
                <h6>View in Augmented Reality</h6>
            </section>
            <MuiDialogContent dividers className={classes.root}>
                <section className={classes.promptBody}>
                    <div className={classes.promptTips}>
                        <section className={classes.promptRow}>
                        <section className={classes.promptIcon}>
                            <img src={tipsIcon} alt="Double Tap Device" />
                        </section>
                        <section className={classes.promptCopy}>
                            <h5>No AR Browser Support</h5>
                            <p>Please copy this link into Safari or Chrome to continue to your curated experience.</p>
                        </section>
                        </section>
                    </div>
                </section>
            </MuiDialogContent>
            <section className={classes.modalFooter}>
                <CopyToClipboard text={generateLink()}>
                    <button type="submit"
                            className={classes.default_modal_button}
                            variant="contained"
                            onClick={() => setClicked(!clicked)}>
                            { !clicked ? ("Copy Link") : ("Copied!") }
                    </button>
                </CopyToClipboard>
            </section>
        </Dialog>
    );
}

export default RedirectPrompt;
